
import {Box} from "@mui/material";
import {text} from "stream/consumers";
import {theme} from "../../themes/theme";

interface IVoucherDetailItem{
    title:string
    detail:string
}
export const CustomVoucherDetailItem = ({title,detail}:IVoucherDetailItem) => {
    return (
        <Box sx={{display:"flex", marginBottom:"0.8rem", flexWrap:"wrap"}}>
            <Box width={"12rem"}>
                {title}
            </Box>
            <Box sx={{fontWeight:theme.typography.fontWeightLight}}>
                {detail}
            </Box>
        </Box>
    );
};